<template>
  <div>
    <section>
      <div class="form-inline flex-row">
        <label for="email">Email:</label>
        <div>
          <input
            name="email"
            id="email"
            type="text"
            placeholder="Email"
            v-model="editEmail"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="roles">Roles:</label>
        <div>
          <multi-select
            name="role"
            id="role"
            :options="roleOptions"
            :selected-options="roleItems"
            @select="onSelectRole"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="password">Password:</label>
        <div>
          <input
            name="password"
            id="password"
            type="text"
            placeholder="Password"
            v-model="editPassword"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="sendEmail">Send Email:</label>
        <div>
          <model-select
            :options="sendEmailOptions"
            v-model="editSendEmail"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { MultiSelect, ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";
import { db } from "@/vendor/firebase";

//  import testData from '@/testData.js';     //test data

export default {
  props: ["type", "uid", "email", "roles", "submitLoading"],
  components: {
    MultiSelect,
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      roleOptions: [
        { value: "admin", text: "admin" },
        { value: "consultant", text: "consultant" },
        { value: "client", text: "client" },
      ],
      sendEmailOptions: [
        { value: true, text: "yes" },
        { value: false, text: "no" },
      ],
      searchText: "",
      roleItems: [],
      roleLastSelectItem: {},
      editEmail: "",
      editPassword: null,
      editSendEmail: null,
    };
  },
  watch: {
    uid: function (val) {
      this.initData();
    },
  },
  beforeMount() {},
  created: function () {
    this.initData();
  },
  methods: {
    onSelectRole(items, lastSelectItem) {
      this.roleItems = items;
      this.roleLastSelectItem = lastSelectItem;
    },
    reset() {
      this.roleItems = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.roleItems = _.unionWith(
        this.roleItems,
        [this.roleOptions[0]],
        _.isEqual
      );
    },
    initData: function () {
      if (this.type == "add") {
        this.panelTitle = "Add Role";
        this.buttonLabel = "Add Role";
        this.editEmail = "";
        this.roleItems = [];
      }
      if (this.type == "edit") {
        this.panelTitle = "Edit Role";
        this.buttonLabel = "Edit Role";
        this.editEmail = this.email;
        this.roleItems = [];
        for (const i in this.roles) {
          this.roleItems.push({
            value: this.roles[i],
            text: this.roles[i],
          });
        }
      }
      this.$forceUpdate();
    },
    buttonClick: function () {
      const roles = [];
      for (const i in this.roleItems) {
        roles.push(this.roleItems[i].value);
      }
      if (this.editPassword && this.editPassword.length < 8) {
        this.$toasted.global.toast_error({
          message: "please use at least 8 characters for the password",
        });
        return;
      }
      this.$emit(
        "buttonClick",
        this.editEmail,
        roles,
        this.editPassword,
        this.editSendEmail
      );
    },
  },
};
</script>
